import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import withOptions from 'utils/functions/withOptions.util';
import isMissing from 'utils/predicates/any/isMissing.util';

const parseBool = withOptions(({ value: raw, noEmpty, noImpure }) => {
  const bool = fromAnyToBool(raw);

  const empty = raw === '' || raw === null || raw === void 1;
  const pure = raw === false || raw === true;
  const missing = isMissing(raw);

  const valid = (noEmpty ? !empty : true) && (noImpure ? !noImpure : true);
  const is = { valid, empty, pure, missing };

  return { bool, is, raw };
});

export default parseBool;
